import React, { Component } from "react";
import { connect } from "react-redux";
import CardForm from "Utils/Cards/CardForm";
import { TrasladoForm } from "./components/TrasladoForm";
import "./CreacionTraslado.css";

class CreacionTraslado extends Component {
    state = {
        traslado_id: null,
    };

    componentWillMount() {
        this.setState({ traslado_id: this.props.match.params.id });
    }

    regresar = () => {
        this.props.history.goBack();
    };

    render() {
        return (
            <div className="mb-4 col-12" style={{ maxWidth: "95vw" }}>
                <CardForm
                    icon="traslados_activo"
                    titulo="CREAR TRASLADO"
                    subtitulo=""
                    col="12"
                >
                    <TrasladoForm
                        traslado_id={this.state.traslado_id}
                        regresar={this.regresar}
                        configuraciones={this.props.configuraciones}
                        user={this.props.user}
                    />
                </CardForm>
            </div>
        );
    }
}

const mstp = (state) => {
    const configuraciones = state.configuracion.configuraciones;
    const user = state.login.me;

    return {
        configuraciones,
        user,
    };
};

export default connect(mstp, {})(CreacionTraslado);
